module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.title_content,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": function($event) {
        return _vm.submitTap('1')
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "会员手机号码:",
      "prop": "user_mobile",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号码",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.user_mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_mobile", $$v)
      },
      expression: "form.user_mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "会员昵称:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入昵称",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.user_nick),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_nick", $$v)
      },
      expression: "form.user_nick"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择宠物:",
      "prop": "pet_id",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.pet_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "pet_id", $$v)
      },
      expression: "form.pet_id"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "级别一",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "级别二",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提醒类型:",
      "prop": "notice_type",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择提醒类型"
    },
    model: {
      value: (_vm.form.notice_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "notice_type", $$v)
      },
      expression: "form.notice_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "级别一",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "级别二",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日:",
      "prop": "notice_date",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择时间"
    },
    model: {
      value: (_vm.form.notice_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "notice_date", $$v)
      },
      expression: "form.notice_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通知方式:",
      "prop": "notice_method",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.notice_method),
      callback: function($$v) {
        _vm.$set(_vm.form, "notice_method", $$v)
      },
      expression: "form.notice_method"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "级别一",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "级别二",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提醒内容:",
      "prop": "notice_content",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请输入需要提醒的内容......"
    },
    model: {
      value: (_vm.form.notice_content),
      callback: function($$v) {
        _vm.$set(_vm.form, "notice_content", $$v)
      },
      expression: "form.notice_content"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "15px",
      "margin-top": "10px",
      "color": "grey"
    }
  }, [_vm._v("\n\t\t\t\t参考短信内容："), _c('br'), _vm._v("\n\t\t\t\t距离旺财的上一次驱虫已经60天了，惠心宠物提醒您，它的健康会换来您的快乐。\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitTap('1')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "FF7"
    },
    on: {
      "click": function($event) {
        return _vm.submitTap('2', 'ruleForm')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcd17354"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/addNotice.vue
// module id = 3509
// module chunks = 103